(() => {
  const dialog = document.getElementById('CardUpsell');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const body = dialog.querySelector('[data-card-upsell-body]');
  const loadingHtml = body.innerHTML;
  const maxQuantity = 10;
  let content; // Promise of the dialog content (section card-upsell-picker), loaded once per page.
  let artworkId; // Artwork of the offer that opened the dialog.

  function loadContent() {
    if (!content) {
      content = fetch(`${routes.cart_url}?section_id=card-upsell-picker`).then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      });
      content.catch(() => (content = null));
    }
    return content;
  }

  async function open(offer) {
    artworkId = offer.dataset.artworkId;
    body.innerHTML = loadingHtml;
    dialog.showModal();
    try {
      body.innerHTML = await loadContent();
    } catch (error) {
      body.textContent = window.cartStrings.error;
      return;
    }
    arrange(offer.dataset.collections.split(',').filter(Boolean));
  }

  // Card of the same motif first, then cards of the same motif collection, then the rest.
  function arrange(collections) {
    const same = body.querySelector('[data-group="same"]');
    const more = body.querySelector('[data-group="more"]');
    const options = Array.from(body.querySelectorAll('.card-upsell__option'));
    const match = options.find((option) => option.dataset.artworkId === artworkId);

    options.forEach((option) => {
      const related = option.dataset.collections.split(',').some((handle) => handle && collections.includes(handle));
      if (related && option !== match) same.append(option);
    });
    if (match) (same.children.length > 0 ? same : more).prepend(match);

    const grouped = same.children.length > 0 && more.children.length > 0;
    body.querySelectorAll('[data-group-title]').forEach((title) => (title.hidden = !grouped));
    same.hidden = same.children.length === 0;
    more.hidden = more.children.length === 0;
    body.querySelector('.card-upsell__picker').hidden = options.length < 2;

    select(match || same.firstElementChild || more.firstElementChild);
  }

  function select(option) {
    if (!option) return;
    body
      .querySelectorAll('.card-upsell__option')
      .forEach((other) => other.setAttribute('aria-pressed', other === option));

    showImages(option.dataset.images.split(',').filter(Boolean), option.dataset.title);
    body.querySelector('.card-upsell__motif').textContent = option.dataset.title;
    body.querySelector('.card-upsell__price .price-item').textContent = option.dataset.price;
    body.querySelector('.card-upsell__add').dataset.variantId = option.dataset.variantId;
    body.querySelector('.card-upsell__error').hidden = true;
  }

  // Image slider: swipe or scroll, the next image peeks in on the right, dots show the position.
  function showImages(images, title) {
    const slider = body.querySelector('.card-upsell__slider');
    const dots = body.querySelector('.card-upsell__dots');
    slider.replaceChildren(
      ...images.map((src, index) => {
        const slide = document.createElement('div');
        slide.className = 'card-upsell__slide';
        const image = new Image(900, 900);
        image.src = src;
        image.alt = `${title} blessing card, image ${index + 1} of ${images.length}`;
        // The second image peeks in, so it loads right away too.
        if (index > 1) image.loading = 'lazy';
        slide.append(image);
        return slide;
      })
    );
    dots.replaceChildren(
      ...images.map((src, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'card-upsell__dot';
        dot.dataset.slide = index;
        dot.setAttribute('aria-label', `Show image ${index + 1} of ${images.length}`);
        return dot;
      })
    );
    dots.hidden = images.length < 2;
    slider.scrollLeft = 0;
    updateDots();
  }

  function slideStep(slider) {
    const slides = slider.children;
    return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slider.clientWidth;
  }

  function showSlide(index) {
    const slider = body.querySelector('.card-upsell__slider');
    slider.scrollTo({ left: index * slideStep(slider), behavior: 'smooth' });
  }

  function updateDots() {
    const slider = body.querySelector('.card-upsell__slider');
    const current = Math.round(slider.scrollLeft / slideStep(slider));
    body
      .querySelectorAll('.card-upsell__dot')
      .forEach((dot, index) => dot.setAttribute('aria-current', index === current));
  }

  function step(delta) {
    const input = body.querySelector('[data-card-upsell-quantity]');
    input.value = Math.min(maxQuantity, Math.max(1, (parseInt(input.value) || 1) + delta));
  }

  // Adds the card and re-renders the cart page, or else the cart notification, from the same response.
  async function addToCart(variantId, quantity) {
    const cartItems = document.getElementById('main-cart-items') && document.querySelector('cart-items');
    const notification = document.querySelector('cart-notification');
    const sections = cartItems
      ? cartItems.getSectionsToRender().map((section) => section.section)
      : ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];

    const response = await fetch(`${routes.cart_add_url}.js`, {
      ...fetchConfig(),
      body: JSON.stringify({ id: variantId, quantity, sections, sections_url: window.location.pathname }),
    });
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || window.cartStrings.error);

    if (cartItems) {
      cartItems.getSectionsToRender().forEach((section) => {
        const element =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        element.innerHTML = cartItems.getSectionInnerHTML(state.sections[section.section], section.selector);
      });
      refreshOfferSections();
    } else if (notification) {
      notification.renderContents(state);
    }
  }

  async function add(button, quantity, errorElement) {
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');
    errorElement.hidden = true;
    try {
      await addToCart(button.dataset.variantId, quantity);
      if (dialog.open) dialog.close();
    } catch (error) {
      errorElement.textContent = error.message;
      errorElement.hidden = false;
    } finally {
      button.removeAttribute('aria-disabled');
    }
  }

  // The offer section on the cart page (card-upsell-offer) depends on the cart content.
  function refreshOfferSections() {
    document.querySelectorAll('[data-card-upsell-section]').forEach((container) => {
      fetch(`${routes.cart_url}?section_id=${container.dataset.cardUpsellSection}`)
        .then((response) => response.text())
        .then((html) => {
          const source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-card-upsell-section]');
          if (source) container.innerHTML = source.innerHTML;
        })
        .catch((error) => console.error(error));
    });
  }

  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshOfferSections);

  // Offers are re-rendered with the cart, so listen on the document.
  document.addEventListener('click', (event) => {
    const offer = event.target.closest('[data-card-upsell]');
    if (!offer) return;

    // The whole offer opens the dialog, except its add button.
    const addButton = event.target.closest('[data-card-upsell-add]');
    if (addButton) {
      add(addButton, 1, offer.querySelector('.card-upsell-teaser__error'));
      return;
    }
    open(offer);
  });

  // Load the dialog content as soon as the customer comes near an offer.
  ['pointerover', 'focusin'].forEach((type) =>
    document.addEventListener(type, (event) => {
      if (event.target.closest && event.target.closest('[data-card-upsell]')) loadContent().catch(() => {});
    })
  );

  dialog.addEventListener('click', (event) => {
    // The cart notification closes on any click that reaches the body.
    event.stopPropagation();
    if (event.target === dialog || event.target.closest('.card-upsell-dialog__close')) {
      dialog.close();
      return;
    }

    const dot = event.target.closest('.card-upsell__dot');
    if (dot) {
      showSlide(parseInt(dot.dataset.slide));
      return;
    }
    const slide = event.target.closest('.card-upsell__slide');
    if (slide) {
      showSlide(Array.from(slide.parentElement.children).indexOf(slide));
      return;
    }
    const option = event.target.closest('.card-upsell__option');
    if (option) {
      select(option);
      body.querySelector('.card-upsell__detail').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }
    const stepButton = event.target.closest('[data-card-upsell-step]');
    if (stepButton) {
      step(parseInt(stepButton.dataset.cardUpsellStep));
      return;
    }
    const addButton = event.target.closest('[data-card-upsell-add]');
    if (addButton) {
      const quantity = parseInt(body.querySelector('[data-card-upsell-quantity]').value) || 1;
      add(addButton, Math.min(maxQuantity, Math.max(1, quantity)), body.querySelector('.card-upsell__error'));
    }
  });

  // Scroll events do not bubble, and the slider is replaced on every open.
  dialog.addEventListener(
    'scroll',
    (event) => {
      if (event.target.classList && event.target.classList.contains('card-upsell__slider')) updateDots();
    },
    true
  );

  // Close on keyup instead of keydown, otherwise the same Escape keyup also closes the cart notification.
  dialog.addEventListener('cancel', (event) => event.preventDefault());
  dialog.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') dialog.close();
  });
})();
